import mapKnownValues from "@/utils/mapKnownValues";

export enum StationDisconnectHistoryEventName {
  connect = "CONNECT",
  disconnect = "DISCONNECT"
}

export type StationDisconnectHistoryItemResponse = {
  serial: string;
  chargieId: string;
  createdAt: string; // date
  reconnectedAt: string;
  eventType: string | null;
  clusterName: string;
  stationId: string;
  note: null;
  lastChargeProfile: string | null;
};

export default class StationDisconnectHistoryItem {
  eventType: string | null = null;
  serial = "";
  chargieId = "";
  createdAt = new Date();
  reconnectedAt: Date | null = new Date();
  clusterName = "";
  stationId = "";
  note = null;
  lastChargeProfile: string | null = null;

  constructor(params: Partial<StationDisconnectHistoryItem>) {
    mapKnownValues(this, params);
  }

  get stationName() {
    if (this.chargieId) return this.chargieId;
    return this.serial;
  }

  get eventName() {
    switch (this.eventType) {
      case "SERVICE_CLOSED":
      case "STATION_CLOSED":
        return StationDisconnectHistoryEventName.disconnect;
      default:
        return StationDisconnectHistoryEventName.connect;
    }
  }

  static fromAPI(response: StationDisconnectHistoryItemResponse) {
    return new StationDisconnectHistoryItem({
      ...response,
      createdAt: new Date(response.createdAt),
      reconnectedAt: response.reconnectedAt ? new Date(response.reconnectedAt) : null
    });
  }
}
